<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import FormModal from "@Components/Modal/FormModal.vue";
import { PrimaryButton } from "@Components/Button";
import LinkForm from "./LinkForm.vue";

const props = defineProps({
    postTypes: Array,
});
const emit = defineEmits(["created"]);

const { t: __ } = useI18n();

const modal = ref();
const form = useForm({
    mode: "post",
    post_id: null,
    custom_url: "",
    keywords: "",
    max_links: 1,
    post_types: props.postTypes.map((type) => type.name),
    is_blank: false,
    is_follow: true,
    is_obfuscated: false,
});

const store = () => {
    form.post("linking_manual_store").then(() => {
        modal.value.hide();

        form.reset();

        emit("created");
    });
};

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" @submit="store" :title="__('Créer un lien')" max-height="80vh">
        <template #body>
            <LinkForm :postTypes="postTypes" v-model="form" />
        </template>
        <template #actions>
            <div class="flex justify-end items-center">
                <PrimaryButton :processing="form.processing" type="submit" :z="1">
                    {{ __("Créer") }}
                </PrimaryButton>
            </div>
        </template>
    </FormModal>
</template>
